const NUMBER = 'number';
const TEXT = 'text';
const EMAIL = 'email';
const FLOAT = 'float';
const NONE = 'none'
const BOOLEAN = 'checkbox';



module.exports = {
    NUMBER,
    TEXT,
    EMAIL,
    FLOAT,
    NONE,
    BOOLEAN
}



// WEBPACK FOOTER //
// ./src/constants/formtypes.js